var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-loading': _vm.$store.state.loading.status },attrs:{"id":'page-' + _vm.$route.name}},[_c('navbar'),_vm._v(" "),_c('router-view',{key:_vm.$route.name,attrs:{"keep-alive":""}}),_vm._v(" "),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }